import React from 'react';
import { Modal } from 'react-bootstrap';
import classnames from 'classnames';

function isLegacySize(size) {
  return size === 'legacy';
}

function setSizeProp(size) {
  if (!isLegacySize(size)) return size;
}

function setLegacySize(size) {
  if (isLegacySize(size)) return size;
}

function isHtmlChildren(component) {
  const { type } = component;
  return typeof type === 'string';
}

function getChildren(children, onCloseRequested) {
  if (children) {
    if (isHtmlChildren(children)) {
      return children;
    } else {
      return React.cloneElement(children, {
        onCloseRequested: onCloseRequested
      });
    }
  }
}

/**
 * @param {object} props
 * @param {boolean} props.isOpen - (required)
 * @param {() => void} props.onCloseRequested - (required)
 * @param {string} props.id - (required)
 * @param {string} [props.size='legacy']
 * @param {boolean} [props.outerClose]
 * @param {object} props.children - (required)
 * @param {boolean} [props.buttonPositionStatic]
 * @param {boolean} [props.dark]
 * @param {string} [props.backdropClass]
 * @param {boolean} [props.isError]
 */
const Popup = ({
  isOpen,
  onCloseRequested,
  id,
  size = 'legacy',
  dark,
  backdropClass,
  outerClose,
  children,
  isError,
  buttonPositionStatic
}) => {
  return (
    <div className={classnames('modal-parent', 'sub-' + id)}>
      {outerClose && (
        <button
          type="button"
          className={isOpen ? 'outer-close' : 'hide'}
          onClick={onCloseRequested}
        />
      )}
      <Modal
        backdropClassName={classnames(backdropClass, { isError })}
        className={classnames({
          dark,
          isError,
          buttonPositionStatic,
          legacySize: setLegacySize(size)
        })}
        dialogClassName={id}
        onHide={onCloseRequested}
        size={setSizeProp(size)}
        animation={true}
        show={isOpen}
        id={id}
      >
        <div className="close-button-wrap">
          <button type="button" className="close" onClick={onCloseRequested}>
            <i className="icon-cross" />
          </button>
        </div>
        {getChildren(children, onCloseRequested)}
      </Modal>
    </div>
  );
};


export default Popup;
